import { END_POINT_SEVER } from "../constants";
import axios from "axios";
import {
  SuccessSwal,
  WarningError,
  WarningNetworkFailure,
} from "../helpers/alertseet";
import { jwtDecode } from "jwt-decode";
import convertMessage from "../helpers/convertMessage";

export const get_staffs = async (findby = "", token) => {
  try {
    const decoded = jwtDecode(token);
    const url = `${END_POINT_SEVER}/api/staff/getAllStaff${findby}branchId=${decoded?.branchId}&isDelete=false`;

    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    // hide isDelete
    // let data = res.data?.data?.filter((e) => !e?.isDelete);
    // const response = { total: res.data?.total, data: data };

    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_staff = async (_id, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/staff/get/${_id}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }
    console.error("error", error);
    return { error: true };
  }
};

export const add_staff = async (data, token) => {
  try {
    const decoded = jwtDecode(token);
    const url = `${END_POINT_SEVER}/api/staff/create`;
    const res = await axios.post(
      url,
      { ...data, branchId: decoded?.branchId },
      {
        headers: { authorization: `Bearer ${token}` },
      }
    );
    SuccessSwal("ສ້າງຊີສຳເລັດ!");
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const update_staff = async (_id, data, token) => {
  try {
    const decoded = jwtDecode(token);
    const url = `${END_POINT_SEVER}/api/staff/update/${_id}`;
    const res = await axios.put(
      url,
      { ...data, branchId: decoded?.branchId },
      {
        headers: { authorization: `Bearer ${token}` },
      }
    );
    SuccessSwal("ແກ້ໄຂຊີສຳເລັດ!");
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const delete_staff = async (_id, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/staff/delete/${_id}`;
    console.log("url: " + url);
    const res = await axios.delete(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    SuccessSwal("ລຶບບັນຊີສຳເລັດ!");
    return res.data;
  } catch (error) {
    console.log("step error message: ", error?.response?.data?.message);
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.response.data.message === "MANAGER_CANNOT_BE_DELETED") {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};
